module.exports = __webpack_public_path__ + "static/media/rim-front-right.24dd0f11.svg";